module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1174.39ead83b.png";